import { useEffect } from 'react';
import { useWorldStore } from '../state/worldStore';
import { ROOMS } from '../rooms';
import { audioEngine } from '../services/audioEngine';

// RoomSound — a room that brings its own sound takes the district station's
// place while you are in it.
//
// Khari, 2026-08-06: "when the user enters the salon, fade the main music out
// (if it is not already muted).. the rooms have their own ambiance.. The salon
// has gossip and the news on the TV.. Sometimes live.. concert halls, for
// example. When the user leaves the room, fade the main music back on (if it
// was on when they entered)."
//
// WHY A ROOM FLAG rather than "every interior": some rooms have nothing of
// their own to say, and silence there is just a room with the radio switched
// off. Declaring it per room (`ROOMS.<id>.ownSound`) means adding a venue to
// this behaviour is one field, and a room that only sometimes has something
// live — the concert hall between shows — can decide for itself later without
// a second mechanism.
//
// Deliberately NOT duck(): a duck dips and yields for a moment, which is right
// for a bark or a call and wrong here. A radio at 10% under the gossip reads as
// something nobody switched off. The station goes, and comes back on the way
// out — the restore rules live in audioEngine.roomQuiet.
//
// Mounted once, at the top level, because it is about the TRANSITION between
// rooms — a component that unmounts when you leave cannot fade anything back in.
export default function RoomSound() {
  const interior = useWorldStore((s) => s.interior);

  useEffect(() => {
    const quiet = !!(interior && ROOMS[interior]?.ownSound);
    audioEngine.roomQuiet(quiet).catch(() => {});
    // No cleanup that releases the hold: leaving is `interior` becoming null,
    // which re-runs this with quiet=false. A cleanup would ALSO fire on every
    // room-to-room move and fight the entry it is handing over to.
  }, [interior]);

  return null;
}
